<template>
  <div class="camera-modal">
    <div class="camera-modal-content">
      <button class="close-button" @click="closeCameraModal">
        <i class="fa fa-times close-icon"></i>
      </button>
      <div class="camera-modal-header">
        <span>{{ title }}</span>
        <p>{{ description }}</p>
      </div>

      <div class="col-12" v-if="isPhoto">
        <slot></slot>
      </div>

      <template v-else>
        <img v-if="capturedImage" class="col-12" id="avatar-hora" :src="capturedImage" />
        <img v-else class="col-12" id="avatar-hora" :src="require(`@/assets/${imageName}`)" />
      </template>

      <button v-if="loading" class="col-12 camera-modal-button" disabled>
        <div class="d-flex justify-content-center">
          <div role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="24"></component>
          </div>
        </div>
      </button>

      <button v-else class="col-12 camera-modal-button" @click="handleEvent">
        {{ buttonText }}
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'

export default {
  props: {
    title: String,
    description: String,
    buttonText: String,
    loading: Boolean,
    isPhoto: Boolean,
    imageName: String,
    capturedImage: String
  },
  components: {
    ...spinners,
  },
  methods: {
    closeCameraModal() {
      this.$emit('close-modal')
    },
    handleEvent() {
      this.$emit('handle-event')
    }
  }
}
</script>

<style scoped lang="scss">
.camera-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.camera-modal-content {
  max-width: 31.25rem;
  width: 100%;
  padding: 1.5rem 1rem;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;

  background: #fff;
  border-radius: 5px;
  position: relative;
}

.camera-modal-header {
  max-width: 27rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.camera-modal-header>span {
  color: #0F0E0E;
  font-size: 1.5rem;
  font-weight: 700;
}

.camera-modal-header>p {
  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 600;
}

.camera-modal-button {
  padding: 1.5rem 0.75rem;
  border: 0;
  border-radius: 4px;
  background: #FABF10;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 700;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1;
}

.close-icon {
  font-size: 20px;
  color: red;
}

.camera-modal-content img {
  width: 100%;
  max-height: 100%;
  margin: 0 auto;
}

video {
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
